import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import ArticlePreview from "../components/article-preview"
import Carousel from "../components/carousel"
import BlogTags from "../components/blog-tags"
import blogHero from "../images/ML_hero-blog-image.jpg"
import blogImage from "../images/ml_hero_blog.svg"

const ArchivedPosts = props => {
  const carouselData = [
    {
      title: `Posts about <span class="highlight">${props.pathContext.tags}</span>`,
      backgroundImage: blogHero,
      image: blogImage,
    },
  ]

  const posts = props.data.allContentfulBlogPost.edges
  const tagsList = props.data.allContentfulBlogTags.edges
  return (
    <Layout>
      <div className="carousel-slick-bottom">
        <Carousel data={carouselData} />
      </div>
      <section className="section section-padding section-blog">
        <div className="centre">
          <BlogTags tags={tagsList} />
          <div className="blog-main blog-archive ">
            <ArticlePreview articles={posts} />
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ArchivedPosts

export const pageQuery = graphql`
  query BlogPostByTag($tags: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogTags {
      edges {
        node {
          tags
        }
      }
    }
    allContentfulBlogPost(
      filter: { tags: { elemMatch: { tags: { eq: $tags } } } }
    ) {
      edges {
        node {
          title
          node_locale
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags {
            tags
          }
          description {
            childMarkdownRemark {
              html
            }
          }
          articlePreviewImage {
            description
            file {
              url
            }
          }
        }
      }
    }
  }
`
